module.exports = __webpack_public_path__ + "img/cleaned_floor.a0b18d63.svg";